<app-page-heading *ngIf="!isCarrier; else emptyHeader"
                  [key]="title"
                  [subheadingIcon]="subheadingIcon"
                  [disableMarginBottom]="true"
                  [carrierSelectPlaceholderKey]="selectCarrierPlaceholder"
                  [regions]="regions"
                  [(selectedRegion)]="selectedRegion"
                  (selectedRegionChange)="onSelectedRegionChange($event)"
                  [carriers]="carriers"
                  [(selectedCarrier)]="selectedCarrier"
                  (selectedCarrierChange)="onSelectedCarrierChange($event)"
                  [clearable]="clearable"
                  [needVendorNumber]="needVendorNumber"
                  [forceShowCarrier]="true">
    <ng-container class="page-heading-right-content" *ngTemplateOutlet="headingRightContent"></ng-container>
</app-page-heading>

<ng-template #emptyHeader>
    <app-page-heading [key]="title"
                      [subheadingIcon]="subheadingIcon"
                      [disableMarginBottom]="true">
        <ng-container class="page-heading-right-content" *ngTemplateOutlet="headingRightContent"></ng-container>
    </app-page-heading>
</ng-template>

<ng-template #headingRightContent><ng-content></ng-content></ng-template>
